
export enum ErrorCode {
  // {message: "Invalid zip file!", code: "aErD004"}
  aErD004 = 'aErD004',
  // {"message":"Maximum file size exceeded!","code":"aErD003"}
  aErD003 = 'aErD003',
  // {"message":"Bad file extension!","code":"aErD002"}
  aErD002 = 'aErD002',
}
